var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1, .cls-2 { fill: none; stroke: #ffffff; stroke-linecap: round; stroke-width:2.88; } .cls-1 { stroke-linejoin: round; } .cls-2 { stroke-miterlimit: 10; } .cls-3 { fill: #ffffff; } ")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.30639,11.25243a5.29412,5.29412,0,1,0-10.58824,0,5.23707,5.23707,0,0,0,.584,2.37007A5.27955,5.27955,0,0,0,8.8358,23.95831"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.58191,21.56266a7.00047,7.00047,0,1,0,11.32225,6.78321V28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43086,42.32855A6.21606,6.21606,0,0,1,5.108,36.82494a6.14985,6.14985,0,0,1,.68573-2.78316"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,16a5,5,0,0,1-5,5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "19 16.01 30.5 16.01 32.521 13.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "25.5 20.01 31.5 20.01 33.521 17.99 39 17.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "24.917 31.99 30.5 31.99 32.521 34.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "24.917 27.99 31.5 27.99 33.521 30.01 39 30.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39,38.01018H31.52094l-1.52061-2.02061-4.95867.00011v6.05209a5,5,0,0,1-10,0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.04167,4.13392a4.05277,4.05277,0,0,1,8,.91833V12.01l4.45868.00013L31.521,9.98956H39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36,
    x2: 25.04167,
    y1: 24,
    y2: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 11,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 11.79167,
    cy: 43.5,
    r: 1
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.47922,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.47922,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.47922,
    cy: 30,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.47922,
    cy: 38,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem2);
export default __webpack_public_path__ + "static/media/item2.11bd2b3edd504190c84ff22f6eb61e14.svg";
export { ForwardRef as ReactComponent };